import api from './api';

const base = '/admin/convenios';

export async function listConvenios({ q = '', page = 1, limit = 25 } = {}) {
  const { data } = await api.get(base, { params: { q, page, limit } });
  return data;
}

export async function createConvenio(payload) {
  const { data } = await api.post(base, payload);
  return data;
}

export async function updateConvenio(codConv, payload) {
  const { data } = await api.put(`${base}/${codConv}`, payload);
  return data;
}

export async function deleteConvenio(codConv) {
  const { data } = await api.delete(`${base}/${codConv}`);
  return data;
}
